import script from "./EpDocModeloEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EpDocModeloEditPage.vue?vue&type=script&setup=true&lang=js"

import "./EpDocModeloEditPage.vue?vue&type=style&index=0&id=23ad5e9b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23ad5e9b"]])

export default __exports__